import { useT } from '@/core/I18nProvider';

import { legalDocDate } from './legal-doc-dates';

import type { LegalDocSlug } from './legal-doc-dates';
import type { ReactElement } from 'react';

/**
 * The dated freshness marker rendered under the heading of every binding legal
 * document (privacy, terms, DPA, cookies, refunds, AI compliance, disclosure).
 *
 * Mirrors the `Compliance` / `Subprocessors` pages' last-updated line — the
 * localized `legal.lastUpdated` label plus a machine-readable `<time>` — and
 * reads its date from the {@link legalDocDate} SOT so the marker can never drift
 * from the document's real last-revision date.
 */
export function LegalLastUpdated({ slug }: { slug: LegalDocSlug }): ReactElement {
  const { t } = useT();
  const date = legalDocDate(slug);
  return (
    <p className="mt-3 text-sm text-[color:var(--bd-muted)]">
      {t('legal.lastUpdated')} <time dateTime={date}>{date}</time>
    </p>
  );
}
